module.exports = __webpack_public_path__ + "img/foreveralone.e06691ef.jpg";